import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ScrollAware from './scroll-aware.js';

/**
 * Used for responsive where the sidebar element is mounted.
 * If it is not found, the sidebar position returned will be 0.
 */
const SidebarScrollAware = ({ children, isDesktop }) => {
	// Finds the sidebar element that scrolls it's content
	// A custom scrollbar is used on desktop which adds a couple
	// of nested divs where the last one is the scrolling one.
	const scrollingElement = isDesktop
		? document.querySelector('#sidebar > div > div')
		: document.getElementById('sidebar'); // FIXME_SIDEBAR

	return (
		<ScrollAware scrollingContainer={scrollingElement}>{scrollYPosition => children(scrollYPosition)}</ScrollAware>
	);
};

SidebarScrollAware.propTypes = {
	children: PropTypes.func.isRequired
};

export default connect(state => ({
	isDesktop: state.brand.isDesktop
}))(SidebarScrollAware);
